"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function EstatesGrid() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="102365" className="grid grid-cols-1 gap-16 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center">
            <div className="w-full mb-6">
              <AspectRatio ratio={1 / 1}>
                <div className="h-full w-full bg-muted/20 animate-pulse rounded-none" />
              </AspectRatio>
            </div>
            <div className="h-6 w-3/4 bg-muted/20 animate-pulse mb-2" />
            <div className="h-4 w-1/2 bg-muted/20 animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-sm font-sans text-muted-foreground">
        Failed to load our collections.
      </div>;
  }
  if (terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-16 md:grid-cols-3">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "/ShopPage"} data-index={i} className="group flex flex-col items-center text-center focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary focus-visible:ring-offset-4">
          <div className="w-full mb-8 overflow-hidden bg-white border border-border p-4 shadow-sm transition-shadow duration-500 group-hover:shadow-md">
            <AspectRatio ratio={1 / 1}>
              {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105 mix-blend-multiply" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/10">
                  <span className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">No Image</span>
                </div>}
            </AspectRatio>
          </div>
          <h3 className="mb-3 text-3xl font-serif font-normal tracking-tight text-primary italic">
            {term.name}
          </h3>
          <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-primary/60">
            {term.description || "Estate Grown & Bottled"}
          </p>
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 6,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function DistinguishedEstates() {
  return <section id="curated-collections" className="bg-background text-foreground py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-20 text-center">
          <h2 className="text-5xl md:text-6xl font-serif font-normal leading-tight tracking-tight text-primary">
            Curated Collections
          </h2>
          <div className="mt-4 h-px w-24 bg-secondary mx-auto" />
        </div>
        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <EstatesGrid />
        </EcommerceTermsProvider>
      </div>
    </section>;
}